<template>
  <header :class="$style.header">
    <a
      :class="$style.headerLink"
      href="https://jumpcloud.com"
    >
      <JumpcloudBrandmark
        color="jcSecondary"
        :scale="1.5"
        type="jcLogoWordmarkTM"
      />
    </a>
  </header>
</template>

<script>
import { JumpcloudBrandmark } from '@jumpcloud/ui-components';

export default {
  name: 'Header',

  components: {
    JumpcloudBrandmark,
  },
};
</script>

<style module>
.header {
  background-color: var(--jcTertiary);
  padding: 1.5rem 1rem;
  width: 100%;
}
</style>
